export default __webpack_public_path__ + "static/media/collin-image.3c523519.gif";